import * as React from 'react';

// import { FaBeer } from 'react-icons/fa';

import './navDrawerButton.css'

export interface INavDrawerButtonProps {
  // NavDrawerButtonIsHorizontal: boolean
  ToggleButton: () => void
}

export default class INavDrawerButton extends React.PureComponent<INavDrawerButtonProps, any> {
  public render() {
    return (
      // <div>
      <div className='topspacing'>
        <span onClick={ this.props.ToggleButton } className='icon' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/navToolbar/navDrawerButton/navDrawerButton.tsx